import { render, staticRenderFns } from "./MozLoader.vue?vue&type=template&id=454283ea&scoped=true&"
import script from "./MozLoader.vue?vue&type=script&lang=js&"
export * from "./MozLoader.vue?vue&type=script&lang=js&"
import style0 from "./MozLoader.vue?vue&type=style&index=0&id=454283ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454283ea",
  null
  
)

export default component.exports